import { gql } from '@apollo/client'

export const GET_REPORT_STATUS = gql`
  query getReportStatus($organisationID: ID!) {
    getReportStatus(organisationID: $organisationID) {
      reports {
        year
        status
        url
      }
    }
  }
`
